import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import * as Api from "@/api";
import Search from "@/design/components/Search";
import useSearch from "@/utils/hooks/useSearch";
import Valkyrie, { viPlus, viXmark } from "@sippy-platform/valkyrie";

import { Box, Button, Drawer, IconButton, List, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";

import SoundItem from "./SoundItem";

function MusicOnHold({ musicOnHold, musicOnHoldDispatch }) {
  const soundStore = useSelector((state) => state.domain.sounds);

  const [searchValue, setSearchValue] = useState("");
  const searchResults = useSearch(soundStore.list, searchValue, ["name"]);

  useEffect(() => {
    Promise.resolve(Api.getSounds());
  }, []);

  const [drawer, setDrawer] = useState(false);

  const closeDrawer = useCallback(() => {
    setDrawer(false);
    setSearchValue("");
  }, []);

  return (
    <>
      <Button
        variant="contained"
        onClick={() => setDrawer(true)}
        startIcon={<Valkyrie icon={viPlus} />}
        disabled={musicOnHold?.entries.length >= 10 || !musicOnHold?.id}
        id="addSound"
      >
        Add sound
      </Button>
      <Drawer
        open={drawer}
        onClose={() => closeDrawer()}
        anchor="right"
        slotProps={{
          paper: {
            sx: (theme) => ({ maxWidth: 320, width: 1, p: 1.5, display: "flex", gap: 1, ...theme.scrollbar }),
            elevation: 4,
          },
        }}
      >
        <Stack
          direction="row"
          sx={{
            gap: 1,
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Add sound</Typography>
          <IconButton onClick={() => closeDrawer()} color="inherit">
            <Valkyrie icon={viXmark} />
          </IconButton>
        </Stack>
        <Typography>You can add up to 10 sounds to a playlist. A single sound can be added more than once.</Typography>
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000 }}>
          <Search blur value={searchValue} onChange={setSearchValue} />
        </Box>
        <List>
          {searchResults.map((sound) => (
            <SoundItem
              key={sound.id}
              musicOnHold={musicOnHold}
              musicOnHoldDispatch={musicOnHoldDispatch}
              sound={sound}
              closeDrawer={closeDrawer}
            />
          ))}
        </List>
      </Drawer>
    </>
  );
}

MusicOnHold.propTypes = {
  musicOnHold: PropTypes.object,
  musicOnHoldDispatch: PropTypes.func,
};

export default MusicOnHold;
